import { checkStatus } from '../../utilities/fetch';
import { XMLHTTPResponse } from '../../utilities/types';
import { createQueryString } from '../../utilities/utilities';
import { newslabNewsletterPath, subscriptionsPath } from '../../utilities/api_relative_paths';
import { GetNewslettersResponse } from '../types/types';

import {
  extendNewslettersWithSubscribedField
} from '../utilities/ua.utilities';

const getNewslettersForUA = (): Promise<GetNewslettersResponse> =>
  fetch(newslabNewsletterPath + createQueryString({ page: { size: 100 } }))
    .then((response: XMLHTTPResponse) => checkStatus(response))
    .then((response) => response.json())
    .then(extendNewslettersWithSubscribedField)
    .catch(Promise.reject);

const getNewslettersForSpecificEmail = (email: string): Promise<GetNewslettersResponse> =>
  fetch(
    subscriptionsPath +
      createQueryString({
        page: { size: 100 },
        email,
      })
  )
    .then((response: XMLHTTPResponse) => checkStatus(response))
    .then((response) => response.json())
    .catch(Promise.reject);

export { getNewslettersForUA, getNewslettersForSpecificEmail };
